module.exports = __webpack_public_path__ + "img/ops_logo_es.71f2f6b0.svg";